import Connection from '../Connections/Connection';
import PineconeConnection from '../Connections/PineconeConnection';
import AWSConnection from '../Connections/AWSConnection';
import MongoDBConnection from '../Connections/MongoDBConnection';

class SemanticMemory {
  similarityThreshold: number;
  connections: Connection[];

  constructor(
    similarityThreshold: number, 
    connections: Connection[] = []
  ) {
    this.similarityThreshold = similarityThreshold;
    // Validate all connections
    connections.forEach(conn => {
      if (typeof conn.toJson !== 'function') {
        throw new Error('Non-Connection instance found in SemanticMemory.connections during construction');
      }
    });
    this.connections = connections;
  }

  addConnection(connection: Connection): void {
    if (typeof connection.toJson !== 'function') {
      throw new Error('Attempted to add a non-Connection instance to SemanticMemory.connections');
    }
    this.connections.push(connection);
  }

  removeConnectionByIndex(index: number): boolean {
    if (index >= 0 && index < this.connections.length) {
      this.connections.splice(index, 1);
      return true;
    }
    return false;
  }

  toJson() {
    return {
      similarity_threshold: this.similarityThreshold,
      connections: this.connections.map(connection => connection.toJson())
    };
  }

  static fromJson(json: any): SemanticMemory {
    if (!json) {
      return new SemanticMemory(0.1, []);
    }
    
    const connections = (json.connections || []).map((conn: any) => {
      switch (conn.type) {
        case 'pinecone':
          return PineconeConnection.fromJson(conn);
        case 'aws':
          return AWSConnection.fromJson(conn);
        case 'mongodb_json':
          return MongoDBConnection.fromJson(conn);
        default:
          return Connection.fromJson(conn);
      }
    });
    
    return new SemanticMemory(
      json.similarity_threshold || 0.1,
      connections
    );
  }
}

export default SemanticMemory;